import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import styled from "styled-components";

const Input = styled.input.attrs(props => ({
  type: "text",
  size: props.small ? 5 : undefined
}))`
  height: 32px;
  width: 200px;
  border-radius: 5px;
  border: 1px solid var(--buttons-color, #30b1ff);
  padding: 0 16px;
  outline: none;
  background: #fff;
`;

const Select = styled.select`
  height: 32px;
  min-width: 160px;
  border-radius: 5px;
  border: 1px solid var(--buttons-color, #30b1ff);
  padding: 0 12px;
  outline: none;
  background: #fff;
`;

const Button = styled.button`
  height: 32px;
  white-space: nowrap;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
`;

const PatientsListFilter = ({
  onClear,
  onSearch,
  filterText,
  filterStatus,
  filterICVerification,
}) => {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState(filterText || "");
  const [status, setStatus] = useState(filterStatus || "");
  const [icVerification, setIcVerification] = useState(filterICVerification || "");

  useEffect(() => {
    setSearchText(filterText || "");
    setStatus(filterStatus || "");
    setIcVerification(filterICVerification || "");
  }, [filterText, filterStatus, filterICVerification]);
  
  const handleClear = () => {
    onClear();
    setSearchText('');
    setStatus('');
    setIcVerification('');
  };

  const handleSearch = () => {
    onSearch(searchText, status, icVerification);
  };

  return (
    <Container>
      <Input
        type="text"
        placeholder={t('Search...')}
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />
      
      <Select
        value={status}
        onChange={(e) => setStatus(e.target.value)}
      >
        <option value="">{t('Select Status')}</option>
        <option value="Pending">{t('Pending')}</option>
        <option value="Approved">{t('Approved')}</option>
        <option value="Rejected">{t('Rejected')}</option>
        <option value="Deleted">{t('Deleted')}</option>
      </Select>

      <Select
        value={icVerification}
        onChange={(e) => setIcVerification(e.target.value)}
      >
        <option value="">{t('IC Verification')}</option>
        <option value="pending">{t('Pending')}</option>
        <option value="approved">{t('Approved')}</option>
        <option value="rejected">{t('Rejected')}</option>
        <option value="re-submission">{t('Re-submission')}</option>
      </Select>

      <Button
        type="button"
        className="btn btn-custom-color btn-hover-shine"
        onClick={handleSearch}
      >
        {t('Search')}
      </Button>
      <Button
        type="button"
        className="btn btn-custom-color btn-hover-shine"
        onClick={handleClear}
      >
        {t('Reset')}
      </Button>
    </Container>
  );
};

export default PatientsListFilter;
